import {
  DashboardOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  TeamOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  NotificationOutlined,
  ThunderboltOutlined,
  CarOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import AdminUserMenu from './AdminUserMenu';
import { stripPathLanguage } from '../../i18nLanguages';
import MyButtonText from '../../components/myButton/MyButtonText';
const getSelectedKey = (pathname) => {
  if (pathname.startsWith('/dashboard')) return '/dashboard';
  if (pathname.startsWith('/users')) return '/users';
  if (pathname.startsWith('/products')) return '/products';
  if (pathname.startsWith('/cart-requests')) return '/cart-requests';
  if (pathname.startsWith('/car-washes')) return '/car-washes';
  if (pathname.startsWith('/notifications')) return '/notifications';
  if (pathname.startsWith('/stress-test')) return '/stress-test';
  return pathname;
};

const AdminSider = ({ onSelect, collapsed, onCollapse }) => {
  const { pathname } = useLocation();
  const selectedKey = getSelectedKey(stripPathLanguage(pathname));
  const { t } = useTranslation();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: t('WORD_DASHBOARD'),
    },
    {
      key: '/users',
      icon: <TeamOutlined />,
      label: t('WORD_USERS'),
    },
    {
      key: '/products',
      icon: <AppstoreOutlined />,
      label: t('WORD_PRODUCTS'),
    },
    {
      key: '/cart-requests',
      icon: <ShoppingCartOutlined />,
      label: t('CART_REQUESTS'),
    },
    {
      key: '/car-washes',
      icon: <CarOutlined />,
      label: t('WORD_CAR_WASHES'),
    },
    {
      key: '/notifications',
      icon: <NotificationOutlined />,
      label: t('WORD_NOTIFICATIONS'),
    },
    {
      key: '/stress-test',
      icon: <ThunderboltOutlined />,
      label: t('WORD_STRESS_TEST'),
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: t('WORD_SETTINGS'),
    },
  ];

  return (
    <div className="admin_sider_inner">
      <div className="admin_brand">
        {!collapsed && (
          <>
            <div className="admin_brand_mark">ص</div>
            <div className="admin_brand_text">
              <strong>saffati</strong>
              <span>{t('WORD_ADMIN')}</span>
            </div>
          </>
        )}
        <MyButtonText
          className="admin_collapse_btn"
          onClick={onCollapse}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </MyButtonText>
      </div>

      <Menu
        mode="inline"
        items={menuItems}
        selectedKeys={[selectedKey]}
        onClick={({ key }) => {
          if (key.startsWith('/')) onSelect?.(key);
        }}
        className="admin_menu"
      />

      <div className="admin_sider_footer">
        <AdminUserMenu />
      </div>
    </div>
  );
};

export default AdminSider;
